var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2 7.20003H16.8V16.8H7.2V7.20003ZM6.13333 7.20003C6.13333 6.6027 6.60266 6.13336 7.2 6.13336H16.8C17.3867 6.13336 17.8667 6.6027 17.8667 7.20003V16.8C17.8667 17.3867 17.3867 17.8667 16.8 17.8667H7.2C6.60266 17.8667 6.13333 17.3867 6.13333 16.8V7.20003ZM15.0293 9.87736C15.1893 9.63203 15.1253 9.30136 14.8907 9.1307C14.6453 8.96003 14.3147 9.02403 14.144 9.2587L11.0613 13.7387L9.51466 11.8827C9.32266 11.648 8.98133 11.616 8.75733 11.808C8.52266 11.9894 8.49066 12.3307 8.68266 12.5547L10.6667 14.944C10.7733 15.072 10.9333 15.136 11.0933 15.136C11.2533 15.1254 11.4133 15.04 11.4987 14.9014L14.9653 9.8347L15.0293 9.87736Z",
    fill: "#9DA6AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxIcon);
export default __webpack_public_path__ + "static/media/checkbox-icon.ccf1aafa09cacc01031e784943a80c2f.svg";
export { ForwardRef as ReactComponent };